// SrcVer: $Id: //trak/main/adhocs/T2023/6/CLRS25/internal/web/system/common/config/angularConfig.js#1 $
'use strict';
angular.module('tcApp')
// Remove hash prefix
.config(function($locationProvider) {
	$locationProvider.hashPrefix('');
})
// Remove $log.debug in production to avoid memory leaks
.config(function($logProvider, $windowProvider) {
	if ($windowProvider.$get().location.href.indexOf('HomeDebug.cls') == -1) $logProvider.debugEnabled(false);
});
